import styled from "styled-components";

const ContainerReplicarCatalogo = styled.div`
  padding: 8rem;
  color: ${(props) => props.theme.colors.tertiary};
  position: relative;
  .tituloContainer{
    .titulo{
      margin-bottom: 3rem;
    }
  }
  .column-flex {
    display: inline-flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: center;
    align-items: center;
    .flex-label {
      display: flex;
      gap: 2rem;
      justify-content: flex-start;
      align-items: center;
      margin: 1rem 0;
      &:first-child{
        margin-top: 0;
      }
      &:last-child{
        margin-bottom: 0;
      }
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .row-flex {
    display: flex;
    gap: 2rem;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    cursor: pointer;
    padding-top: 4rem;
    .arrow {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      > svg {
        padding-top: 0.3rem;
        width: 2rem;
        height: 2rem;
      }
    }
  }
`;

const ContainerCatalogo = styled.div`
  width: 100%;
  padding: 5rem 10rem 18rem 10rem;
  .grid-container-catalogo {
    width: 100%;
    position: relative;
    gap: 24px;
    display: grid;
    grid-template-columns: calc(40% - 2px - 3vw) 2px calc(60% - 3vw); //paia isso
    .middle {
      width: 100%;
      height: calc(100vh - 70rem);
      padding-top: 12rem;
      background-color: ${(props) => props.theme.colors.elements};
      align-self: flex-start;
    }
    .left,
    .right {
      gap: 2rem;
      position: relative;
      width: 100%;
      height: 100%;
      color: ${(props) => props.theme.colors.tertiary};
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .container-conteudo {
        opacity: 0;
        transition: 0.3s ease-in-out;
        pointer-events: none;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 10rem;
        left: 0;
        width: 100%;
        padding-bottom: 22rem;
        gap: 3rem;
        .tab-filtrar {
          white-space: nowrap;
        }
        .linha {
          width: 100%;
          height: 2px;
          background-color: ${(props) => props.theme.colors.elements};
          border-radius: 50px;
        }
         .frete-especial{
             .linha {
                 margin-top: 8px;
             }
             .nome-intermediador{
                 margin-bottom: 8px;
             }
             @media (max-width: 1024px) {
               overflow-x: auto;
               -webkit-overflow-scrolling: touch;
               width: 100%;
               max-width: calc(100vw - 6rem);

               .tableContainer {
                 min-width: max-content;
               }
             }
         } 
        .intermediador, .frete-especial{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .linha {
            width: 30%;
            height: 2px;
            background-color: ${(props) => props.theme.colors.elements};
            border-radius: 50px;
            margin-bottom: 8px;
          }
  
          .nome-intermediador{
            text-align: left;
            display: flex;
            justify-content: start;
            font-weight: bold;
            width: 100%;
          }
        }
      }
        .container-produtos{
            top: 0;
        }
      .no-padding {
        top: 3rem;
      }
      .container-ativo {
        opacity: 1;
        pointer-events: all;
      }
      .bold {
        font-weight: bold;
        width: 100%;
        text-align: left;
      }
      .texto-produtos{
        justify-content: start !important;
      }
      .flex {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 1rem;
        text-align: left;
        .linha {
          width: 30%;
          height: 2px;
          background-color: ${(props) => props.theme.colors.elements};
          border-radius: 50px;
          margin-bottom: 8px;
        }
        .nome-intermediador{
          font-weight: bold;
          width: 100%;
          padding-top: 10px;
        }
        .descricao-texto{
          display: none;
        }
        .input-container{
          padding: 1rem 0;
        }

        > span {
          width: 100%;
          text-align: left;
          display: flex;
          align-items: center;
          gap: 1rem;

          .locked{
            font-weight: 400;
          }
        }
        > label {
          display: flex;
          width: 100%;
          gap: 1rem;
          flex-wrap: wrap;
          align-items: center;
        }
      }

      .flexPromocao{
        flex-wrap: nowrap;
      }
      .no-wrap {
        flex-wrap: nowrap;
      }
      .nowrap {
        white-space: nowrap;
      }
      .space-between {
        justify-content: space-between;
      }
      .grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(40%, 1fr));
        gap: 2rem;
      }
      .grid-mobile {
        display: flex;
        width: 100%;
      }
      .expiracao {
        display: block;
        transition: 0.3s ease-in-out;
        pointer-events: none;
        opacity: 0;
      }
      .ativo {
        pointer-events: inherit;
        opacity: 1;
      }
      .exemplo {
        color: ${(props) => props.theme.colors.placeholder};
      }
      .half-width {
        width: 48%;
        min-width: 35rem;
        flex-grow: 1;
      }
      .filtrar-produtos-container {
        position: relative;
        width: 100%;
      }
    }
    .footer-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 1.5rem;
      margin-bottom: 1.5rem;
      color: ${(props) => props.theme.colors.tertiary};
      gap: 2rem;
      flex-wrap: wrap;
    }
    .footer-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap-reverse;
      gap: 2rem;
      .green {
        color: ${(props) => props.theme.colors.primary};
        cursor: pointer;
        @media (max-width: 1024px) {
          min-height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .right-flex {
        white-space: normal;
        display: flex;
        gap: 2rem;
        align-items: center;
        a {
          display: contents;
        }
        .cinza {
          color: ${(props) => props.theme.colors.tertiary};
          font-weight: normal;
          background-color: ${(props) => props.theme.colors.elements};
        }
      }
    }
    @media (max-width: 1024px) {
      grid-template-columns: 1fr;
      height: auto;
      .left,
      .right {
        .container-conteudo {
          top: 0;
          padding-bottom: 0;
          position: relative;
          display: none;
        }
        .container-ativo {
          display: flex;
        }
      }
      .footer-wrapper {
        .right-flex {
          display: contents;
        }
      }
    }
    @media (max-width: 680px) {
      .footer-wrapper {
        gap: 1rem;
        .button {
          width: 100% !important;
        }
      }
    }
  }
  @media (max-width: 1024px) {
    padding: 5rem 3rem 40rem 3rem;
  }

  /* Estilos da aba Promoções */
  .promocoes-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    .promocao{
        padding: 2rem 0;
    }
    .toggle-promocao {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      padding: 2rem 0;
      border-bottom: 1px solid ${(props) => props.theme.colors.elements};

      &:last-child {
        border-bottom: none;
      }

      .toggle-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        gap: 1rem;

        .toggle-label {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
      }

      .toggle-content {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        padding-top: 1rem;
        opacity: 0;
        max-height: 0;
        overflow: hidden;
        transition: all 0.3s ease-in-out;
        pointer-events: none;

        &.ativo {
          opacity: 1;
          max-height: 100rem;
          pointer-events: all;
        }
      }
    }
  }

  /* Container para opções de escopo (radio buttons) */
  .escopoAjustePreco {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    margin: 0.5rem 0;

    label {
      display: flex;
      align-items: center;
      gap: 0.8rem;
      cursor: pointer;

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }

  /* Badge "Em breve" */
  .badge-em-breve {
    font-size: 1.1rem;
    background: ${(props) => props.theme.colors.elements};
    padding: 0.2rem 0.6rem;
    border-radius: 4px;
    margin-left: 0.5rem;
  }

  /* Row de inputs (tipo, ajuste, valor) */
  .ajustePrecoInputs {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
    margin-top: 0.5rem;

    > div {
      flex: 1;
      min-width: 25rem;
    }

    @media (max-width: 680px) {
      flex-direction: column;

      > div {
        width: 100%;
      }
    }
  }

  /* Inputs de mínimo de compra lado a lado */
  .minimoCompraInputs {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
    padding-bottom: 2rem;

    > div {
      flex: 1;
      min-width: 14rem;
    }

    @media (max-width: 680px) {
      flex-direction: column;

      > div {
        width: 100%;
      }
    }
  }

  /* Desconto Progressivo */
  .descontoProgressivoContainer {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
  }

  .descontoProgressivoInputs {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
    align-items: flex-end;

    > div {
      flex: 1;
      min-width: 10rem;
    }

    @media (max-width: 680px) {
      flex-direction: column;

      > div {
        width: 100%;
      }
    }
  }

  .botao-criar-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin: 2rem 0;

    @media (max-width: 680px) {
      button {
        width: 100%;
      }
    }
  }

  .linhaRegras {
    width: 100%;
    height: 1px;
    background-color: ${(props) => props.theme.colors.white};
    margin: 1.5rem 0 1rem 0;
  }

  .tituloRegras {
    width: 100%;
    display: flex;
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
    text-align: left;
  }

  .subitem {
    padding-top: 1rem;
    padding-left: 4rem;
  }

  .descontoProgressivoTable {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    @media (max-width: 1024px) {
      max-width: calc(100vw - 6rem);

      .tableContainer {
        min-width: max-content;
      }
    }
  }

  .acoes-desconto {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    .editar-link {
      color: ${(props) => props.theme.colors.primary};
      cursor: pointer;
      white-space: nowrap;
    }
  }
`;

export { ContainerCatalogo, ContainerReplicarCatalogo };

